import React, { Component } from "react"
import { connect } from 'react-redux'
import { saveTransactionAction} from '../../redux/actions/MainAction'
import {  MessageText } from '../../configs'
import {setIsAcceptAction,setIsPoAcceptAction} from '../../redux/actions/ApproveAction'
import moment from 'moment'
class SubmitMethodModal extends Component {


    constructor(props) {
        super(props)

        this.state = {
            ...props,
            is_accept: true,
            is_po_accept:true,

        }
        this.handleChange = this.handleChange.bind(this)
    }
    handleChange(event){

        const name = event.target.name;
        let value = event.target.type === 'checkbox' ? (event.target.checked ? true : false) : event.target.value;
        const xname = event.target.name;
        if (name == "is_accept"){
           this.props.setIsAccept(value);
        } else if (name=== "is_po_accept"){
            this.props.setIsPoAccept(value);
        }

        this.setState({
            [name]: value
        })


    }

    handleSubmit(event,source,isSubmit,status)
    {
        this.props.onHandleSubmit(event,source, isSubmit, status);
    }

    componentDidMount(){
        let {is_accept,is_po_accept} = this.state;
        this.props.setIsAccept(is_accept);

        this.props.setIsPoAccept(is_po_accept);
    }

    getRpaShowState(){
        
        const {
            po_no,
            t_GR_ITEM,
            t_GR_ITEM_ACCOUNT_ASSIGNMENT
        } = this.props
        
        let is_rpa = true 

        let is_profit_segment = false
        let is_subcontracting = false
        let is_purchase_consumption = false 

        //Case : Profit segment
        // Item Assg. :  J 
        // Item Cat. : ทุกค่า
        t_GR_ITEM.forEach(item => {
            if(item.a==="J" && (item.checked === '1' || item.checked === 1 || item.checked === true)){
                is_profit_segment = true
            }
        });
        
        t_GR_ITEM.forEach(item => {
            if(item.i==="L" && (item.checked === '1' || item.checked === 1 || item.checked === true)){
                is_subcontracting = true
            }
        });

        let is_f = false
        let is_multiple_account_assignment = false
        let is_contract= po_no && po_no.startsWith('41')
        
        t_GR_ITEM.forEach(item => {
            if(item.a==="F" && (item.checked === '1' || item.checked === 1 || item.checked === true)){
                is_f = true
            }
        });
        
        is_multiple_account_assignment = (t_GR_ITEM_ACCOUNT_ASSIGNMENT.length > 1);
        var key = ""
        t_GR_ITEM_ACCOUNT_ASSIGNMENT.forEach(item => {
            if(key!== item.item_no)
            {
                key = item.item_no
              is_multiple_account_assignment = false
            }
            else
            {
              is_multiple_account_assignment = true
              return
            }
            });
        is_purchase_consumption = is_contract && is_f &&is_multiple_account_assignment;

        is_rpa = is_rpa && !is_profit_segment && !is_subcontracting && !is_purchase_consumption
            
        return is_rpa
    }

    handleDateDiffNow = (date) =>{
        let now = new Date();
        now = new Date(now.getFullYear(), now.getMonth(), now.getDate());
        return moment(now).diff(date, 'days')
    }
    
    render() {
       
        const { transaction, t_MR_DETAIL } = this.props
       const {is_accept, is_po_accept } = this.state

       console.log('t_MR_DETAIL', t_MR_DETAIL)

       const showCommitteeTimeToConsiderFlag = t_MR_DETAIL && t_MR_DETAIL.audit_committee_time_to_consider_flag === true && t_MR_DETAIL.audit_committee_time_to_consider_date && this.handleDateDiffNow(t_MR_DETAIL.audit_committee_time_to_consider_date) > 0

        let is_rpa = this.getRpaShowState()
        var countCommitteeNotApprove = this.props.t_PO_COMMITTEE.filter(committee => committee.approve_status === 'N')

        let is_unanimous = (countCommitteeNotApprove.length>0)
        return (
            <div className="modal fade sp-modal rrs-modal" id="SubmitMethodModal" tabIndex={-1} role="dialog" aria-labelledby="SubmitMethodModalLabel" aria-hidden="true">
                <div className="modal-dialog modal-lg modal-dialog-centered" role="document">
                    <div className="modal-content">
                        <div className={showCommitteeTimeToConsiderFlag === true ? "modal-header Component-root-80 bg-danger" : "modal-header"}>
                            <h5 className="modal-title" id="SubmitMethodModalLabel">แจ้งเตือน</h5>
                            <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                                <span aria-hidden="true">×</span>
                            </button>
                        </div>
                        <div className="modal-body rrs-container">
                            {/* <h5 className="modal-title" align="center">กรุณาเลือกวิธีการดำเนินการต่อไป</h5> */}
                            {
                             is_unanimous && (
                            <div className="row rrs-fine-box">
                            <div className="col-1"></div>
                            <div className="col-11 col-rrs-checkbox">
                                <label className={`checkboxcontainer rrs-fine-label clickable`}>ผู้มีอำนาจอนุมัติสั่งการให้รับพัสดุ/สินค้า
                                <input
                                        type="checkbox"
                                        name="is_po_accept"
                                        defaultValue="is_po_accept"
                                        checked={is_po_accept}
                                        //{this.toBoolean(t_MR_DETAIL.no_penalty_flag)}
                                        onChange={this.handleChange} 
                                        //disabled={t_MR_DETAIL.delivery_exception_flag === "in_time"  || viewMode}
                                        //ref={this.penalty_no_result_ref}
                                        //ref={this.no_penalty_flag_ref}
                                        />
                                    <span className="checkboxmark" />
                                </label>
                            </div>
                            </div>
                                )}
                            { showCommitteeTimeToConsiderFlag === false && <div className="row rrs-fine-box">
                            <div className="col-1"></div>
                            <div className="col-10 col-rrs-checkbox">
                                <label className={`checkboxcontainer rrs-fine-label clickable`}>ข้าพเจ้าได้ตรวจสอบและขอยืนยันว่า ข้อมูลที่บันทึกนี้เป็นไปตามมติการประชุมของ คณะกรรมการตรวจรับหรือผู้ตรวจรับพัสดุ/สินค้า ทุกประการ
                                <input
                                        type="checkbox"
                                        name="is_accept"
                                        defaultValue="is_accept"
                                        checked={is_accept}
                                        //{this.toBoolean(t_MR_DETAIL.no_penalty_flag)}
                                        onChange={this.handleChange} 
                                        //disabled={t_MR_DETAIL.delivery_exception_flag === "in_time"  || viewMode}
                                        //ref={this.penalty_no_result_ref}
                                        //ref={this.no_penalty_flag_ref}
                                        />
                                    <span className="checkboxmark" />
                                </label>
                            </div>
                            </div>}

                            {showCommitteeTimeToConsiderFlag === true && <div className="row rrs-fine-box">
                                <div className="col-1"></div>
                                <div className="col-10">
                                    <label className={`checkboxcontainer rrs-fine-label clickable text-danger`}>
                                        
                                        กำหนดวันที่ คกก.ตรวจรับพัสดุ ต้องพิจารณาแล้วเสร็จ คือ {moment(t_MR_DETAIL.audit_committee_time_to_consider_date).format('DD/MM/YYYY')} ซึ่งเกินกำหนดระยะเวลาพิจารณาของคณะกรรมการตรวจรับ ให้เสนอผู้มีอำนาจอนุมัติสั่งซื้อสั่งจ้าง พิจารณาขยายให้ตามความจำเป็น</label>
                                </div>
                                </div>
                            }

                                <div className="rrs-detail">    
                                    <div className="col-12 sp-header-button-panel2 justify-content-center">
                                    { showCommitteeTimeToConsiderFlag === true ?  <a href="#" className="sp-btn-icon btn-ok " data-dismiss="modal" aria-label="Close"
                                            onClick={(event) => {  }}  >
                                            <i className="icon btn-order-check-green" />
                                            <span className="sp-btn-icon-label3">{MessageText.APP.MSG_BOX_BUTTON_TEXT_AGREE}</span>
                                        </a> :
                                        <a href="#" className="sp-btn-icon btn-ok " data-dismiss="modal" aria-label="Close"
                                            onClick={(event) => { this.handleSubmit(event, this, true,'VERI')  }}  >
                                            <i className="icon btn-order-check-green" />
                                            <span className="sp-btn-icon-label3">{MessageText.APP.MSG_BOX_BUTTON_TEXT_OK}</span>
                                        </a>}
                                    </div>                                   
                                </div>
                            
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

const mapStateToProps = state => {
    const { MainRedux} = state
    return {
      transaction: MainRedux.transaction,
      t_GR_ITEM: MainRedux.t_GR_ITEM,
      t_GR_ITEM_ACCOUNT_ASSIGNMENT: MainRedux.t_GR_ITEM_ACCOUNT_ASSIGNMENT,
      t_PO_COMMITTEE : MainRedux.t_PO_COMMITTEE,
      t_MR_DETAIL: MainRedux.t_MR_DETAIL,
      po_no: MainRedux.po_no,
    }
  }
  
  const mapDispatchToProps = dispatch => {
    return {
      //saveTransaction: (transaction) => dispatch(saveTransactionAction(transaction))
      setIsAccept:(isActive) => dispatch(setIsAcceptAction(isActive)),
      setIsPoAccept:(isActive) => dispatch(setIsPoAcceptAction(isActive)),
    }
  }
  
  export default connect(
    mapStateToProps,
    mapDispatchToProps
  )(SubmitMethodModal)